import { Methods } from "@newview/infrastructure";
import { NewviewOaBaseApi } from "./NewviewOaBaseApi";


export class ApplyWorkoverApi extends NewviewOaBaseApi {

    public get ControllerName(): any {
        return 'apply-workover'
    }


    /**
     * 获取加班时长
     * @param startTime 
     * @param endTime 
     * @returns 
     */
    public getWorkHours(startTime, endTime) {
        return this.send({ startTime: startTime, endTime: endTime }, "getWorkHours", this.Methods.GET)
    }

    /**
     * 获取当前时间前6个月的加班时长
     * @param userId
     */
    public getOverHours(userId){
        return this.send({ userId: userId}, "getOverHours", this.Methods.GET)
    }


}